import React from 'react';
import { Globe, Instagram, Heart } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_bc81a99d-52aa-4670-bd05-bad277666170/artifacts/or4rxw3y_Icono%20Principal%20-%20WildSoul.png" 
                alt="Viajeros Conectados" 
                className="w-10 h-10 object-contain"
              />
              <div>
                <h3 className="text-lg font-bold">Viajeros Conectados</h3>
                <p className="text-sm text-gray-400">Grupos de WhatsApp</p>
              </div>
            </div>
            <p className="text-gray-400 text-sm">
              Conectamos viajeros de todo el mundo para compartir experiencias, consejos y aventuras inolvidables.
            </p>
          </div>
          
          <div>
            <h4 className="font-bold text-lg mb-4">Sobre nosotros</h4>
            <p className="text-gray-400 text-sm mb-3">
              Somos creadores de contenido de viajes apasionados por descubrir el mundo y ayudar a otros viajeros a planificar sus aventuras.
            </p>
            <a 
              href="https://instagram.com/wildsoultravellers" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-orange-400 hover:text-orange-300 transition-colors"
            >
              <Instagram className="w-5 h-5" />
              <span className="font-medium">@wildsoultravellers</span>
            </a>
          </div>
          
          <div>
            <h4 className="font-bold text-lg mb-4">Información</h4>
            <p className="text-gray-400 text-sm mb-4">
              Esta plataforma es informativa. No nos responsabilizamos del contenido compartido en los grupos de WhatsApp.
            </p>
            <p className="text-gray-400 text-sm">
              Los enlaces de afiliación nos ayudan a mantener este servicio gratuito sin costo adicional para ti.
            </p>
          </div>
        </div>
        
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm text-center md:text-left">
            © 2025 Viajeros Conectados. Hecho con <Heart className="w-4 h-4 inline text-red-500" /> para viajeros
          </p>
          
          <div className="flex items-center gap-6">
            <a href="#destinos" className="text-gray-400 hover:text-white transition-colors text-sm">
              Destinos
            </a>
            <a href="https://instagram.com/wildsoultravellers" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors text-sm">
              Instagram
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
